import {Link} from 'react-router-dom';

import {toAbsoluteUrl} from '@/utils';
import {useLayout} from '@/providers';
import {KeenIcon} from "@/components";

const ResetPasswordCheckEmail = () => {
    const {currentLayout} = useLayout();

    return (
        <div className="card max-w-[440px] w-full">
            <div className="card-body p-10">
                <div className="flex justify-center py-10">
                    <img
                        src={toAbsoluteUrl('/media/illustrations/30.svg')}
                        className="dark:hidden max-h-[130px]"
                        alt=""
                    />
                    <img
                        src={toAbsoluteUrl('/media/illustrations/30-dark.svg')}
                        className="light:hidden max-h-[130px]"
                        alt=""
                    />
                </div>

                <h3 className="text-lg font-medium text-gray-900 text-center mb-3">Check Your Email</h3>
                <div className="text-2sm text-center text-gray-700 mb-7.5">
                    Please click the link sent to your email
                    <br/>
                    to reset your password. Thank you.
                </div>

                <Link
                    to={currentLayout?.name === 'auth-branded' ? '/auth/login' : '/auth/classic/login'}
                    className="flex items-center justify-center text-sm gap-2 text-gray-700 hover:text-primary"
                >
                    <KeenIcon icon="black-left"/>
                    Back to Login
                </Link>

                {/*
        <div className="flex items-center justify-center gap-1">
          <span className="text-xs text-gray-600">Didn’t receive an email?</span>
          <Link to="/auth/classic/reset-password/enter-email" className="text-xs font-medium link">
            Resend
          </Link>
        </div>*/}
            </div>
        </div>
    );
};

export {ResetPasswordCheckEmail};
